/**
 * Free-text "describe the job" step, shared by the authenticated wizard and the
 * intake funnel. Heading and placeholder are overridable so each flow can use
 * its own voice; the field behavior (2000-char cap, counter, gated Continue) is
 * identical.
 */
export function DescriptionStep({
  value,
  onChange,
  onContinue,
  heading = "Describe what's needed",
  placeholder = "The kitchen sink is leaking from the trap. Started yesterday.",
}: {
  value: string;
  onChange: (value: string) => void;
  onContinue: () => void;
  heading?: string;
  placeholder?: string;
}) {
  return (
    <div className="space-y-3">
      <h2 className="text-base font-semibold">{heading}</h2>
      <textarea
        autoFocus
        rows={6}
        maxLength={2000}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="block w-full rounded-md border border-slate-300 p-3 text-base focus:border-teal-700 focus:outline-none focus:ring-1 focus:ring-teal-700"
        placeholder={placeholder}
      />
      <p className="text-xs text-slate-500">{value.length} / 2000</p>
      <button
        type="button"
        disabled={value.trim().length < 1}
        onClick={onContinue}
        className="min-h-[44px] w-full rounded-md bg-teal-700 text-sm font-medium text-white disabled:opacity-60"
      >
        Continue
      </button>
    </div>
  );
}
